import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  IonRadioGroupCustomEvent,
  RadioGroupChangeEventDetail,
} from '@ionic/core';

@Component({
  selector: 'app-buddy-language',
  templateUrl: './buddy-language.component.html',
  styleUrls: ['./buddy-language.component.scss'],
})
export class BuddyLanguageComponent {
  @Input() languages: { name: string; localize: string }[];
  selectedIndex = 0;

  @Output() selectedLanguage: EventEmitter<number> = new EventEmitter<number>();

  onLanguageSelected(
    event: IonRadioGroupCustomEvent<RadioGroupChangeEventDetail>,
  ) {
    this.selectedIndex = event.detail.value;
    this.selectedLanguage.emit(this.selectedIndex);
  }
}
